import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded'

import { useArchiveCommunication } from '@/hooks/api/use-communication'

function ArchiveDialog({
    communicationId,
    handleClose,
    successCallback,
}: {
    communicationId: number,
    handleClose: () => void,
    successCallback?: () => void,
}) {

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)

    const mutation = useArchiveCommunication(
        communicationId,
        {
            setRequestInProgress,
            onSuccessCallback(data) {
                if(data) {
                    setSuccess(true)
                }
            }
        },
    )

    const handleClickArchive = () => {
        setRequestInProgress(true)
        mutation.mutate()
    }

    return (
        <Box sx={{
            minWidth: 200,
            minHeight: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {success ?
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                }}>
                    <ArchiveRoundedIcon sx={{
                        color: 'terciary.main',
                        fontSize: '4rem',
                    }}/>
                    <Typography variant="body1" component="div">
                        Vlákno komunikace úspěšně archivováno.
                    </Typography>
                    <Button
                        variant="contained"
                        color="terciary"
                        size="small"
                        onClick={() => {
                            setSuccess(false)
                            if (successCallback) {
                                successCallback()
                            } else {
                                handleClose()
                            }
                        }}
                    >
                        {successCallback ? 'Zpět na seznam' : 'Zavřít'}
                    </Button>
                </Box>
                :
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Typography variant="h5" component="div" mb={2}>
                        Potvrďte prosím archivaci vlákna komunikace ID: {communicationId}
                    </Typography>
                    <Typography variant="body2" component="div" mb={2}>
                        Tato akce celé vlákno zaarchivuje a skryje ze všech seznamů a detailů.
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexGrow: 1,
                    }}>
                        <Button
                            variant="text"
                            color="terciary"
                            onClick={() => handleClose()}
                        >
                            Zrušit
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <ArchiveRoundedIcon />}
                            onClick={() => handleClickArchive()}
                            disabled={requestInProgress}
                        >
                            Archivovat
                        </Button>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default ArchiveDialog
